import PropTypes from "prop-types"
import RootSeriesShape from "./RootSeriesShape"
import DrilldownSeriesShape from "./DrilldownSeriesShape"

const DrilldownShape = {
  rootSeries: PropTypes.arrayOf(PropTypes.shape(RootSeriesShape)),
  drilldownSeries: PropTypes.arrayOf(PropTypes.shape(DrilldownSeriesShape)),
}

export default DrilldownShape



// WEBPACK FOOTER //
// ./src/state/shapes/DrilldownShapes/DrilldownShape.js